import { useUpdateChannelChannelUpdatePostMutation } from '@shared/api';
import type { ChannelTypeEnum } from '@shared/api';
import type { ChannelUpdateFormValues } from '../lib/types';

export const useUpdateChannel = () => {
  const [updateChannelMutation, { isLoading }] = useUpdateChannelChannelUpdatePostMutation();

  const updateChannel = async (
    channelId: number,
    channelType: ChannelTypeEnum,
    values: ChannelUpdateFormValues,
  ) => {
    const normalizedToken = values.token?.trim();
    const normalizedHost = values.host?.trim();
    const normalizedStartMessage = values.startMessage?.trim();
    const normalizedClientId = values.clientId?.trim();
    const normalizedClientSecret = values.clientSecret?.trim();

    const tgBotConfig =
      channelType === 'telegram_bot' || channelType === 'telegram'
        ? {
            token: normalizedToken || null,
            start_message: normalizedStartMessage || null,
          }
        : undefined;

    const vkBotConfig =
      channelType === 'vk_bot'
        ? {
            token: normalizedToken || null,
          }
        : undefined;

    const widgetConfig =
      channelType === 'widget'
        ? {
            host: normalizedHost || null,
            settings_id: values.presetId,
          }
        : undefined;

    const maxBotConfig =
      channelType === 'max_bot'
        ? {
            token: normalizedToken || null,
            start_message: normalizedStartMessage || null,
          }
        : undefined;

    const avitoConfig =
      channelType === 'avito'
        ? {
            client_id: normalizedClientId || null,
            client_secret: normalizedClientSecret || null,
          }
        : undefined;

    try {
      await updateChannelMutation({
        channelId: channelId,
        updateChannel: {
          name: values.name,
          agent_id: values.agentId,
          is_active: values.isActive,
          description: values.description,
          tg_bot_config: tgBotConfig,
          vk_bot_config: vkBotConfig,
          widget_config: widgetConfig,
          max_bot_config: maxBotConfig,
          avito_config: avitoConfig,
        },
      }).unwrap();
    } catch {}
  };

  return {
    updateChannel,
    isLoading,
  };
};
